export default "__VITE_ASSET__BMxbR7EV__"